module.exports = __webpack_public_path__ + "img/almeidatech.9340621c.png";